import React from 'react';

//Global CSS
import './css/app.scss';
import Layout from './components/Layout';

//Enrutado
import { Routes, Route } from 'react-router-dom';

//Genericos
import AccessDeniedPage from './pages/error/AccessDeniedPage';
import NotFoundPage from './pages/error/NotFoundPage';

import Guest from './pages/GuestPage';
import RGPD from './pages/EmailRGPD';
import NotificacionRGPD from './pages/NotificacionRGPD';

export default function App() {
	return (
		<Routes>
			<Route path="/guest/:eventid" element={<Layout component={Guest} />} />
			<Route path="/RGPD/:eventid" element={<Layout component={RGPD} />} />
			<Route
				path="/baja-notificacion/:eventid"
				element={<Layout component={NotificacionRGPD} />}
			/>
			<Route
				path="/restringido"
				element={<Layout component={AccessDeniedPage} />}
			/>
			<Route path="*" element={<Layout component={NotFoundPage} />} />
		</Routes>
	);
}
